import { Dispatcher } from "@fanfanlo";
import { projectModel } from "./ProjectModel";
import _ from "lodash";
export class ProjectController extends Dispatcher{

    constructor(){
        super();
    }
    async init (){
        await projectModel.init();
    }

}

export const projectController = new ProjectController();
